import SetItem from '../items/setItem'
import PushItem from '../items/pushItem'
import AddItem from '../items/addItem'
import MulItem from '../items/mulItem'
import LoadItem from '../items/loadItem'
import ReplaceItem from '../items/replaceItem'
import InvertItem from '../items/invertItem'
import SubItem from '../items/subItem'

const ITEM_DISPLAY_ORDER = [
  'item_set', 'item_push', 'item_add', 'item_sub', 'item_mul', 'item_load', 'item_replace', 'item_invert'
]

const OPERAND_COLORS = [
  0xD63AD4,
  0x9AD63A
]

export default class Inventory extends Phaser.Group {
  constructor (game, stack, player) {
    super(game, null, 'Inventory')

    this.items = {
      'item_set': new SetItem(this.game, stack),
      'item_push': new PushItem(this.game, stack, player.values.positionValue),
      'item_add': new AddItem(this.game, stack),
      'item_sub': new SubItem(this.game, stack),
      'item_mul': new MulItem(this.game, stack),
      'item_load': new LoadItem(this.game, stack),
      'item_replace': new ReplaceItem(this.game, stack),
      'item_invert': new InvertItem(this.game, stack)
    }

    for (let key in this.items) {
      this.add(this.items[key])
    }

    this.setupDescriptionBox()

    this.selectedItem = 0

    this.resetItems()

    this.onItemChanged = new Phaser.Signal()
    this.flashing = false
  }

  errorFlash () {
    if (this.flashing) {
      return
    }

    this.flashing = true
    this.operandTweens = []

    for (let text of this.operandTexts) {
      const tween = this.game.add.tween(text)

      tween.to({alpha: 0}, 150, Phaser.Easing.Linear.None, true, 0, 1)
        .yoyo(true)
        .onComplete.addOnce(() => {
          this.flashing = false
          text.alpha = 1
        })

      this.operandTweens.push(tween)
    }
  }

  setupDescriptionBox () {
    this.descriptionBox = new Phaser.Group(this.game, this, 'descriptionBox')
    this.descriptionBox.x = (ITEM_DISPLAY_ORDER.length + 1) * TILE_WIDTH
    this.descriptionBox.y = 5

    this.instructionNameText = new Phaser.BitmapText(this.game, 0, 0, 'monospace', '', 9)
    this.descriptionBox.add(this.instructionNameText)

    this.operandTexts = []
    this.operandTweens = []
    for (let i = 0; i < 2; i++) {
      const operandText = new Phaser.BitmapText(this.game, 0, 0, 'monospace', '', 9)
      operandText.tint = OPERAND_COLORS[i]

      this.descriptionBox.add(operandText)
      this.operandTexts.push(operandText)
    }
  }

  resetItems () {
    for (let i in ITEM_DISPLAY_ORDER) {
      const itemName = ITEM_DISPLAY_ORDER[i]
      this.items[itemName].x = i * TILE_WIDTH
      this.items[itemName].reset()
    }
  }

  addItem (name, count) {
    this.items[name].setTo(count)
  }

  useSelectedItem () {
    const item = this.getItemByIndex(this.selectedItem)
    if (item.count > 0) {
      const used = item.use()
      this.updateDesciptionText(item)
      if (!used) this.errorFlash()
    }

    if (item.count === 0) {
      this.nextItem()
    }
  }

  selectItem (button) {
    if (button >= ITEM_DISPLAY_ORDER.length) {
      return false
    }

    const item = this.getItemByIndex(button)

    if (item.count > 0) {
      const old_item = this.getItemByIndex(this.selectedItem)

      old_item.select(false)
      item.select(true)

      this.selectedItem = button
      this.updateDesciptionText(item)

      this.onItemChanged.dispatch(item)
      if (this.flashing) {
        for (let tween of this.operandTweens) {
          tween.stop(true)
        }
      }

      return true
    }

    return false
  }

  updateDesciptionText (item) {
    this.instructionNameText.text = `${item.count}x ${item.instructionName}`

    let numCharacters = this.instructionNameText.text.length + 1

    for (let i = 0; i < 2; i++) {
      const operandName = item.operands[i]
      if (operandName) {
        this.operandTexts[i].text = operandName
        this.operandTexts[i].x = numCharacters * 6
        numCharacters += this.operandTexts[i].text.length + 1
      } else {
        this.operandTexts[i].text = ''
      }
    }
  }

  getItemByIndex (index) {
    const itemKey = ITEM_DISPLAY_ORDER[index]
    return this.items[itemKey]
  }

  isItemAvailable (index) {
    const item = this.items[ITEM_DISPLAY_ORDER[index]]
    return item.maxCount > 0 && item.count > 0
  }

  selectFirstItem () {
    for (const i in ITEM_DISPLAY_ORDER) {
      if (this.isItemAvailable(i)) {
        this.selectItem(i)
        break
      }
    }
  }

  nextItem () {
    const selectedItemIndex = parseInt(this.selectedItem)
    for (let i = selectedItemIndex + 1; i < ITEM_DISPLAY_ORDER.length; i++) {
      if (this.isItemAvailable(i)) {
        this.selectItem(i)
        return
      }
    }

    for (let i = 0; i < selectedItemIndex; i++) {
      if (this.isItemAvailable(i)) {
        this.selectItem(i)
        return
      }
    }
  }

  previousItem () {
    const selectedItemIndex = parseInt(this.selectedItem)
    for (let i = selectedItemIndex - 1; i >= 0; i--) {
      if (this.isItemAvailable(i)) {
        this.selectItem(i)
        return
      }
    }

    for (let i = ITEM_DISPLAY_ORDER.length - 1; i > selectedItemIndex; i--) {
      if (this.isItemAvailable(i)) {
        this.selectItem(i)
        return
      }
    }
  }
}
